<template>
  <div>
    <populate-form
      formTitle="自動接受劃位設定時段維護"
      fkey="aa01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
    ></populate-form>
    <b-table
      stacked="sm"
      :items="autoAcceptInstances"
      :fields="fields"
    >
      <template v-slot:cell(actions)="row">
        <b-button @click="editAutoAcceptInstance(row.item)">修改</b-button>
        <b-button class="ml-1" @click="removeAutoAcceptInstance(row.item.id)">刪除</b-button>
      </template>
    </b-table>
    <b-modal
      v-model="modalShowAdd" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="新增自訂自動接受劃位設定"
        fkey="aaa01"
        ref="addForm"
        :parentVue="this"
        populateOptionVar="addOptions"
        formDataObjVar="addData"
      ></populate-form>
    </b-modal>
    <b-modal
      v-model="modalShowEdit" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="修改自訂自動接受劃位設定"
        fkey="aae01"
        ref="editForm"
        :parentVue="this"
        populateOptionVar="editOptions"
        formDataObjVar="editData"
      ></populate-form>
    </b-modal>
    <b-modal
      v-model="modalShowRule" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <StoreAutoAcceptRuleManage
        :checkTimeArrStr="checkTimeArrStr"
      ></StoreAutoAcceptRuleManage>
    </b-modal>
  </div>
</template>

<script>

import StoreAutoAcceptRuleManage from "./SubComponent/StoreAutoAcceptRuleManage"

export default {
  name: 'StoreAutoAcceptManage',
  components:{
    StoreAutoAcceptRuleManage,
  },
  props: {
    
  },
  data: function () {
    return {
      modalShowAdd:false,
      modalShowEdit:false,
      modalShowRule:false,
      service_minute_unit:30,
      autoAcceptInstances:[],
      fields:[
        {
          key:'src',
          label:'來源'
        },
        {
          key:'apply_date',
          label:'日期'
        },
        {
          key:'start_time',
          label:'開始時間'
        },
        {
          key:'end_time',
          label:'結束時間'
        },
        {
          key:'accept_count',
          label:'開放人次'
        },
        {
          key:'restrict_start_times',
          label:'限制'
        },
        {
          key:'created_at',
          label:'建立時間'
        },
        {
          key:'actions',
          label:'操作'
        },
      ],
      filterData:{},
      filterOptions:[
        {
          componentType:'date-picker',
          akey:'from_date',
          defaultValue:'',
          col:2,
          placeholder:'篩選起始日'
        },
        {
          componentType:'date-picker',
          akey:'to_date',
          defaultValue:'',
          col:2,
          placeholder:'篩選結束日'
        },
        {
          componentType:'btn-group',
          col:8,
          buttons:[
            {
              col:2,
              placeholder:'篩選',
              execCallback:this.searchAutoAcceptInstance
            },
            {
              col:3,
              placeholder:"手動新增",
              execCallback:this.showAddRest
            },
            {
              col:3
            },
            {
              col:3,
              placeholder:"規則管理",
              execCallback:this.showManageRule
            }
          ]
        },
      ],
      editData:{},
      editOptions:[
        {
          componentType:'date-picker',
          akey:'apply_date',
          col:4,
          disabled:true,
        },
        {
          componentType:'text',
          col:4,
          akey:'start_time',
          disabled:true,
        },
        {
          componentType:'text',
          col:4,
          akey:'end_time',
          disabled:true,
        },
        {
          componentType:'number',
          akey:'accept_count',
          col:3,
          placeholder:"人次",
          title:"接受人次,值若為2,這段時間已劃位(含自訂)未滿2次即可自動接受",
          defaultValue:"1",
          min:1,
          max:100
        },
        {
          componentType:'text',
          akey:'restrict_start_times',
          col:9,
          placeholder:"限制開始時間(ex:1600,1700)",
          defaultValue:"",
          title:"說明：預設空白即可,若此設定為12:00~18:00且店家設定時段單位是15分鐘,可選劃位開始時間會從12:00,12:15,12:30一路往下產生,此設定是限制可選開始時間,如設定為1200,1300,1400,1500則只有這幾個開始時間會出現在用戶可選自動接受劃位開始時間,12:15,12:30,12:45等時間不提供選擇！",
        },
        {
          componentType:'btn-group',
          col:12,
          buttons:[
            {
              componentType:'b-button',
              col:4,
              placeholder:'取消',
              execCallback:()=>{this.modalShowEdit = false}
            },
            {
              col:1
            },
            {
              componentType:'b-button',
              col:4,
              placeholder:'確認',
              execCallback:this.confirmEdit
            },
          ]
        },
      ],
      addData:{},
      addOptions:[
        {
          componentType:'date-picker',
          akey:'apply_date',
          col:4,
          placeholder:"設定日期"
        },
        {
          componentType:'vue-timepicker',
          col:4,
          akey:'start_time',
          placeholder:"開始時間(請點擊設定)",
          defaultValue:"",
          minuteInterval:this.service_minute_unit,
          minHour:0,
          maxHour:23,
        },
        {
          componentType:'vue-timepicker',
          col:4,
          akey:'end_time',
          placeholder:"結束時間(請點擊設定)",
          defaultValue:"",
          minuteInterval:this.service_minute_unit,
          minHour:0,
          maxHour:23,
        },
        {
          componentType:'number',
          akey:'accept_count',
          col:3,
          placeholder:"人次",
          title:"接受人次,值若為2,這段時間已劃位(含自訂)未滿2次即可自動接受",
          defaultValue:"1",
          min:1,
          max:100
        },
        {
          componentType:'text',
          akey:'restrict_start_times',
          col:9,
          placeholder:"限制開始時間(ex:1600,1700)",
          defaultValue:"",
          title:"說明：預設空白即可,若此設定為12:00~18:00且店家設定時段單位是15分鐘,可選劃位開始時間會從12:00,12:15,12:30一路往下產生,此設定是限制可選開始時間,如設定為1200,1300,1400,1500則只有這幾個開始時間會出現在用戶可選自動接受劃位開始時間,12:15,12:30,12:45等時間不提供選擇！",
        },
        {
          componentType:'span',
          col:4,
        },
        {
          componentType:'b-button',
          col:4,
          placeholder:'確認',
          execCallback:this.confirmAdd
        },
        {
          componentType:'span',
          col:4,
        },
      ],
    }
  },
  methods: {
    showAddRest() {
      this.addData.apply_date = ''
      this.addData.start_time = ''
      this.addData.end_time = ''
      this.addData.accept_count = 1
      this.addData.restrict_start_times = ''
      this.$refs.addForm.initDefault()
      this.modalShowAdd = true
    },
    showManageRule() {
      this.modalShowRule = true
    },
    editAutoAcceptInstance(instance) {
      this.editData = this.CpObj(instance)
      this.modalShowEdit = true
    },
    removeAutoAcceptInstance(id) {
      this.$bus.fnShowConfirm("確認要刪除嗎?", () => {
        let Param = {
          'module':'store',
          'method':'cancelStoreAutoAcceptInstance',
          'store_id': this.$bus.session.merchant_store_id,
          'instance_id':id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              if (!data.data.confirm_remove) {
                vm.$bus.fnClosePopup()
                vm.$bus.fnShowInfo(data.msg)
                return
              }
            }
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo("刪除完成")
          vm.searchAutoAcceptInstance()
        }, this)
      })
    },
    searchAutoAcceptInstance() {
      let Param = {
        'module':'store',
        'method':'getStoreCustomAutoAcceptInstance',
        'store_id': this.$bus.session.merchant_store_id,
        'filter_date_s':this.filterData.from_date?this.filterData.from_date:'',
        'filter_date_e':this.filterData.to_date?this.filterData.to_date:'',
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.autoAcceptInstances =data.data
      }, this)
    },
    confirmAdd() {
      if (!this.addData.apply_date) {
        this.$refs.addForm.triggerAlert('自訂接受劃位日期不正確')
        return
      }
      if (!this.addData.start_time || !this.addData.end_time) {
        this.$refs.addForm.triggerAlert('自動接受劃位開始時間未選擇完成')
        return
      }
      if (this.addData.start_time > this.addData.end_time) {
        this.$refs.addForm.triggerAlert('自動接受劃位結束時間起訖錯誤')
        return
      }
      if (!this.addData.accept_count||this.addData.accept_count < 1 || this.addData.accept_count > 100) {
        this.$refs.addForm.triggerAlert('無效的自動接受劃位人次數字')
        return
      }
      if (!this.checkTimeArrStr(this.addData.restrict_start_times,this.service_minute_unit,this.addData.start_time.substr(0,2),this.addData.start_time.substr(3,2),this.addData.end_time.substr(0,2),this.addData.end_time.substr(3,2))) {
        this.$refs.addForm.triggerAlert('限制可用預約開始時間格式錯誤(起訖時間內的HHmm用逗號串起來且分鐘需為店家最小時間單位倍數)')
        return
      }
      let Param = {
        'module':'store',
        'method':'addStoreCustomAutoAcceptInstance',
        'store_id': this.$bus.session.merchant_store_id,
        'auto_accept_start':this.addData.apply_date+' '+this.addData.start_time,
        'auto_accept_end':this.addData.apply_date+' '+this.addData.end_time,
        'accept_count':this.addData.accept_count,
        'restrict_start_times':this.addData.restrict_start_times
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$refs.addForm.triggerAlert(data.msg)
          return
        }
        setTimeout(() => {
          vm.searchAutoAcceptInstance()
        }, 50);
        vm.$bus.fnClosePopup()
        vm.$bus.fnShowInfo("更新成功")
        vm.modalShowAdd = false
      }, this)
    },
    confirmEdit() {
      if (!this.editData.accept_count||this.editData.accept_count < 1 || this.editData.accept_count > 100) {
        this.$refs.editForm.triggerAlert('無效的自動接受劃位人次數字')
        return
      }
      if (!this.checkTimeArrStr(this.editData.restrict_start_times,this.service_minute_unit,this.editData.start_time.substr(0,2),this.editData.start_time.substr(3,2),this.editData.end_time.substr(0,2),this.editData.end_time.substr(3,2))) {
        this.$refs.editForm.triggerAlert('限制可用預約開始時間格式錯誤(起訖時間內的HHmm用逗號串起來且分鐘需為店家最小時間單位倍數')
        return
      }
      let Param = {
        'module':'store',
        'method':'updateStoreAutoAcceptInstance',
        'store_id': this.$bus.session.merchant_store_id,
        'instance_id':this.editData.id,
        'accept_count':this.editData.accept_count,
        'restrict_start_times':this.editData.restrict_start_times
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$refs.editForm.triggerAlert(data.msg)
          return
        }
        setTimeout(() => {
          vm.searchAutoAcceptInstance()
        }, 50);
        vm.$bus.fnClosePopup()
        vm.$bus.fnShowInfo("更新成功")
        vm.modalShowEdit = false
      }, this)
    },
    checkTimeArrStr(str, unit=1 ,start_hour='00', start_minute='00', end_hour='23',end_minute='59') {
      if (!str) {
        return true
      }
      let arr = str.split(',')
      for (let i=0;i<arr.length;i++) {
        if (arr[i].length !== 4) {
          return false
        }
        let hour = arr[i].substr(0,2)
        let minute = arr[i].substr(2,2)
        let minute_num = parseInt(minute)
        if (minute_num % unit !== 0) {
          return false
        }
        if (!(hour >= start_hour && hour <=end_hour)) {
          return false
        }
        if (!(minute >= '00' && minute <= '59')) {
          return false
        }
        if (hour === start_hour && minute < start_minute) {
          return false
        }
        if (hour === end_hour && minute > end_minute) {
          return false
        }
      }
      return true
    }
  },
  computed: {
    
  },
  created() {
    if (!this.$bus.session.hasOwnProperty('store_service_rule')) {
      // 沒有就抓api寫到session裡,之後讀session
      let Param = {
        'module':'store',
        'method':'getStoreServiceRule',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.session.store_service_rule = data.data
        vm.service_minute_unit = parseInt(data.data.service_minute_unit)
      }, this)
    }
  },
  mounted () {
    this.$refs.filterForm.initDefault()
    setTimeout(() => {
      this.searchAutoAcceptInstance()
      this.addOptions[1].minuteInterval = this.service_minute_unit
      this.addOptions[2].minuteInterval = this.service_minute_unit
      this.$refs.addForm.initDefault()
      
    }, 100);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
